import React from "react";
import { Type, Sticker, MessageSquare } from "lucide-react";
import { ToolType } from "../../types";

interface ToolSelectionProps {
  tool: ToolType;
  onToolChange: (tool: ToolType) => void;
}

const ToolSelection: React.FC<ToolSelectionProps> = ({
  tool,
  onToolChange,
}) => {
  return (
    <div className="w-full mb-6">
      <div
        className="w-full grid grid-cols-3 gap-2 sm:gap-3 lg:gap-4"
        dir="rtl"
      >
        {[
          { id: "text" as const, icon: Type, hebrewLabel: "טקסט" },
          { id: "sticker" as const, icon: Sticker, hebrewLabel: "סטיקרים" },
          { id: "caption" as const, icon: MessageSquare, hebrewLabel: "כיתוב" },
        ].map(({ id, icon: Icon, hebrewLabel }) => (
          <button
            key={id}
            onClick={() => onToolChange(tool === id ? "none" : id)}
            className={`flex flex-col items-center gap-1 px-2 py-2 sm:py-3 rounded-lg font-medium transition-all duration-200 transform hover:scale-105 ${
              tool === id
                ? "bg-gradient-to-r from-pink-600 to-yellow-600 text-white shadow-lg"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
            dir="rtl"
          >
            <Icon className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0" />
            <span className="text-xs sm:text-sm text-center leading-tight">
              {hebrewLabel}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ToolSelection;
